import type { EnvironmentId, ProjectId } from "@cmmd-forge/contracts";

import {
  createRemovableForgeProject,
  destroyCmmdRuntimeForEnvironment,
  removeSidebarProject,
} from "./components/sidebar/sidebarProjectRemoval";
import { readEnvironmentApi } from "./environmentApi";
import { newCommandId } from "./lib/utils";
import type { CheckoutRemoval } from "./projectCheckoutOptions";
import { performCheckoutRemoval } from "./projectCheckoutRemovalRunner";
import type { ProjectGroupRemovalTarget } from "./projectGroupRemovalRunner";

export async function removeProjectGroupCheckoutTarget(
  target: ProjectGroupRemovalTarget,
): Promise<void> {
  const api = readEnvironmentApi(target.environmentId as EnvironmentId);
  if (!api) throw new Error(`No connection for ${target.environmentId}`);
  await api.orchestration.dispatchCommand({
    type: "project.delete",
    commandId: newCommandId(),
    projectId: target.projectId as ProjectId,
  });
}

export function removeSelectedProjectGroupCheckout(removal: CheckoutRemoval): Promise<void> {
  return performCheckoutRemoval(removal, {
    destroyRuntime: (environmentId) =>
      destroyCmmdRuntimeForEnvironment(environmentId as EnvironmentId),
    removeProject: (environmentId, projectId) =>
      removeProjectGroupCheckoutTarget({
        environmentId,
        projectId,
        label: "This machine",
        path: "",
        threadCount: 0,
        kind: "local",
      }),
  });
}

export async function removeProjectGroupTarget(target: ProjectGroupRemovalTarget): Promise<void> {
  await removeSidebarProject(createRemovableForgeProject([target]), { destroyRuntime: false });
}
